export const state = {
    show:false
};

export const mutations = {
    SHOW(state){
        state.show = true
    },
    CLOSE(state){
        state.show = false
    }
};

export const actions = {
    show({ commit }) {
        commit('SHOW');
    },
    close({ commit }) {
        commit('CLOSE');
    }
};
